export const environment = {
  production: false,
  apiUrl:'https://oneringapipreprod.honeywell.com/api/',
  apiCode:'BZYtSaUnuuy7tkvlnMrfCXkm5Gi022LG6Sdi7TCwhp4PAzFu3jqMGw==',
  dataLoadUrl:'',
  // authEndpoint : 'https://login.microsoftonline.com/96ece526-9c7d-48b0-8daf-8b93c90a5d18/oauth2/v2.0/authorize',
  // redirectUri : 'https://oneringuisb.azurewebsites.net',
  // clientId : '09be0f14-6963-473a-aca0-26aa5ec849d2',
  // tenantId: '96ece526-9c7d-48b0-8daf-8b93c90a5d18'
  redirectUri : 'https://oneringpreprod.honeywell.com',
  clientId : 'f41d1527-d645-4fa7-a3c2-f32ea1f455e5',
  tenantId: '96ece526-9c7d-48b0-8daf-8b93c90a5d18',
  localMode: false,
  versionNumber: "1.4.15",
  imageFileTypes:['jpg','jpeg',"png","bmp","tiff","gif"],
  pdfType:["pdf"],
  docTypes:["doc","docx","docm"],
  excelTypes:["csv","xls","xlsm","xlsx"],
  textTypes:["txt"],
  fileTypesSupported:['jpg','jpeg',"png","bmp","gif","pdf","doc","docx","xls","xlsx"],
  idleTimeBeforeWarning: 85,    // idle time before dialog is popped in minutes
  idleWarningTime: 300000,      // time dialog is displayed in msec before you are logged out - 10 minutes
  environmentVariable:'OneRing-PreProd',
  sentryShowdialog: true,
  sentryEnvironment: 'PreProd',
  sentryRelease: '6061',
};
